import type { QBankStructureLevelItemWithLevel } from '@exam-management/qbs-provider';

import { CustomCheckbox } from '../../components';
import { useQBSLevelItemSelection } from '../../providers';

import { getDefaultNameByQBSLevelCategory } from './utils';

interface ChapterLevelItemProps {
  item: QBankStructureLevelItemWithLevel;
  indent?: number;
}

export function ChapterLevelItem(props: Readonly<ChapterLevelItemProps>) {
  const { item, indent = 0 } = props;
  const { updateCheckbox } = useQBSLevelItemSelection();
  const label =
    item.tag?.name ?? getDefaultNameByQBSLevelCategory(item.qBankStructureLevel.category);

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    updateCheckbox(item.id, e.target.checked);
  };

  return (
    <CustomCheckbox
      name={`levelItems.${item.id}`}
      label={label}
      defaultValue={false}
      slotProps={{
        typography: {
          variant: 'body2',
        },
        wrapper: {
          sx: (theme) => ({
            p: theme.spacing(3, 4, 3, 4 * indent + 4),
          }),
        },
      }}
      onChange={handleOnChange}
    />
  );
}
